import React, { useState } from 'react';
import { createContextHook } from 'use-context-hook';
import deleteImg from '../assets/images/warning-gif.gif';
import CenterModal from '../components/molecules/Modal/CenterModal';
import Button from '../components/molecules/Button';
import ConfirmationBlock from '../components/atoms/ConfirmationBlock';
import PricingSection from '../components/atoms/Pricing/PricingSection';

const context = {};

export const DownloadRistrictionContext = createContextHook(context);

export const DownloadRistrictionContextProvider = props => {
  const [downloadRistrictionModal, setDownloadRistrictionModal] = useState(false);

  return (
    <DownloadRistrictionContext.Provider
      value={{
        downloadRistrictionModal:downloadRistrictionModal,
        setDownloadRistrictionModal: setDownloadRistrictionModal,
      }}>
      {props.children}
      <CenterModal open={downloadRistrictionModal} setOpen={setDownloadRistrictionModal} width="1200">
        {/* <ConfirmationBlock
          img={deleteImg}
          title="Download Ristriction!"
          description="You are not authorized to download lists. Please upgrade your plan to download lists."
          btns={
            <>
              <Button variant="danger" onClick={() => setDownloadRistrictionModal(false)} >
                Delete
              </Button>
            </>
          }
        /> */}
        <PricingSection />
      </CenterModal>
    </DownloadRistrictionContext.Provider>
  );
};
